import axiosInstance from './axiosInstance'

export const getShippingVendorById = (vendorId) => {
  return axiosInstance.get(`/shipping-vendors/${vendorId}`)
}

export const getShippingVendors = (page = 1, limit = 50, search = '', orderByKey = 'name', direction = 'asc') => {
  return axiosInstance.get(`/shipping-vendors?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const exportShippingVendors = ({ search = '', orderByKey = 'name', direction = 'asc' } = {}) => {
  return axiosInstance.get(`/shipping-vendors/export?search=${search}&orderByKey=${orderByKey}&direction=${direction}`, { responseType: 'blob' })
}

export const createShippingVendor = (data) => {
  return axiosInstance.post('/shipping-vendors', data)
}

export const updateShippingVendor = (vendorId, data) => {
  return axiosInstance.put(`/shipping-vendors/${vendorId}`, data)
}

export const deleteShippingVendor = (vendorId) => {
  return axiosInstance.delete(`/shipping-vendors/${vendorId}`)
}

export const getShippingVendorNoteById = (vendorId, noteId) => {
  return axiosInstance.get(`/shipping-vendors/${vendorId}/notes/${noteId}`)
}

export const getShippingVendorNotes = (vendorId, page = 1, limit = 50, search = '', orderByKey = 'createdAt', direction = 'desc') => {
  return axiosInstance.get(`/shipping-vendors/${vendorId}/notes?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createShippingVendorNote = (vendorId, data) => {
  return axiosInstance.post(`/shipping-vendors/${vendorId}/notes`, data)
}

export const updateShippingVendorNote = (vendorId, noteId, data) => {
  return axiosInstance.put(`/shipping-vendors/${vendorId}/notes/${noteId}`, data)
}

export const deleteShippingVendorNote = (vendorId, noteId) => {
  return axiosInstance.delete(`/shipping-vendors/${vendorId}/notes/${noteId}`)
}
